import React, { useEffect, useState } from 'react'
import BadgeCard from './BadgeCard'
import TextInput from '../Common/TextInput'

function DeletedBadges({ badges }) {
  const [screenObj, setScreenObj] = useState({
    state: 'idle',
    searchText: '',
    filteredBadges: [],
  })
  const { state, searchText, filteredBadges } = screenObj

  useEffect(() => {
    setScreenObj((data) => ({
      ...data,
      filteredBadges: badges.filter((element) => element.status !== 'available'),
    }))
  }, [badges])

  const getSearchResults = (text) => {
    setScreenObj((data) => ({
      ...data,
      filteredBadges: badges.filter((element) => element.title.toLowerCase().indexOf(text.toLowerCase()) !== -1),
    }))
  }

  const onChangeHandler = (e) => {
    const fieldValue = e.target.value
    setScreenObj((data) => ({
      ...data,
      [e.target.name]: fieldValue,
    }))
    getSearchResults(fieldValue)
  }
  return (
    <>
      <div className='row mt-5'>
        <div className='col-md-10'>
          <TextInput
            itemKey={searchText}
            name='searchText'
            formState={state}
            placeholder="Search by badge's name"
            onChangeHandler={onChangeHandler}
          />
        </div>
        <div className='search-results pe-0 fw-bold text-dark col-md-2 text-end'>{filteredBadges.length} Results</div>
      </div>
      {filteredBadges.length !== 0 ? (
        <div className={`badges-wrapper`}>
          {filteredBadges
            .filter((element) => element.status !== 'available')
            .map((element, index) => (
              <BadgeCard
                key={index}
                title={`${element.title} - ${element.version}`}
                createdAt={new Date(element.dateCreated).toLocaleDateString()}
                imgLink={element.imageURL}
                label='Created at'
                isAllBadges
              />
            ))}
        </div>
      ) : (
        <p className='text-center text-secondary p-5'>No badges found</p>
      )}
    </>
  )
}

export default DeletedBadges
